import { render, staticRenderFns } from "./DetailsViewNav.vue?vue&type=template&id=1462c00a&scoped=true"
import script from "./DetailsViewNav.vue?vue&type=script&lang=js"
export * from "./DetailsViewNav.vue?vue&type=script&lang=js"
import style0 from "./DetailsViewNav.vue?vue&type=style&index=0&id=1462c00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462c00a",
  null
  
)

export default component.exports